import React from 'react';
export const OrnateDivider = ({
  className = ''
}: {
  className?: string;
}) => <div className={`flex items-center justify-center w-full py-8 opacity-80 ${className}`} data-id="element-24">
    <div className="h-px bg-gradient-to-r from-transparent via-gold-600 to-transparent w-1/3" data-id="element-25"></div>
    <div className="mx-4 text-gold-500 text-2xl flex items-center gap-2" data-id="element-26">
      <span className="text-sm" data-id="element-27">✦</span>
      <span data-id="element-28">❧</span>
      <span className="text-sm" data-id="element-29">✦</span>
    </div>
    <div className="h-px bg-gradient-to-r from-transparent via-gold-600 to-transparent w-1/3" data-id="element-30"></div>
  </div>;
export const SimpleDivider = ({
  className = ''
}: {
  className?: string;
}) => <div className={`flex items-center justify-center w-full py-4 opacity-60 ${className}`} data-id="element-31">
    <div className="h-px bg-gradient-to-r from-transparent via-gold-700 to-transparent w-2/3" data-id="element-32"></div>
    <div className="absolute w-2 h-2 rotate-45 bg-gold-600" data-id="element-33"></div>
  </div>;